import React, { useState, useEffect } from 'react';
import {
    API_ADD_LOAN_REPAYMENT_MULTIPLE, API_CENTERS, API_GET_CLIENTS_FOR_REPAYMENT
} from '../Config/ApiUrlConstant'; // Import your constants
import { useAuth } from '../AuthContext'; // Import useAuth hook for access

const branches = [
    { "id": 1, "Branch_no": "BRAN0001", "branch_name": "Mohanw" }
];
const employeeList = [
    { "id": 1, "emp_generate_id": "EMP0001", "emp_name": "Awadhesh Kumar" },
    { "id": 2, "emp_generate_id": "EMP0002", "emp_name": "Manohar Kumar" }
];

const LoanRepaymentList = () => {
    const [formData, setFormData] = useState({
        branch_id: "",
        center_id: "",
        installment_amt: "",
        repayment_paid_by_staff: "",
        selectedClients: [],
        is_closure: 0, // Default to 0,     
        created_at: new Date()
    });
    const [centerList, setCenterList] = useState([]);
    const [clientsForRepayment, setClientsForRepayment] = useState([]);
    const numbers = Array.from({ length: 26 }, (_, index) => index + 1);
    const token = localStorage.getItem('token');
    const { logout } = useAuth();

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Handle branch or center change
        if (name === 'branch_id' && value !== "") {
            getCentersByBranch(value);
        } else if (name === 'branch_id' && value === "") {
            setCenterList([]);
            setClientsForRepayment([]);
            setFormData(prev => ({ ...prev, ['center_id']: "" }));
        } else if (name === 'center_id' && value === "") {
            // handle client reset logic here if needed
            setClientsForRepayment([]);
        }

        // Update form data state
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCheckboxChange = (clientId) => {
        setFormData((prevState) => {
            const selectedClients = prevState.selectedClients.includes(clientId)
                ? prevState.selectedClients.filter((id) => id !== clientId)
                : [...prevState.selectedClients, clientId];

            return { ...prevState, selectedClients };
        });
    };

    const handleSelectAllChange = () => {
        if (formData.selectedClients.length === clientsForRepayment.length) {
            setFormData({ ...formData, selectedClients: [] });
        } else {
            const allClientIds = clientsForRepayment.map(client => client.id);
            setFormData({ ...formData, selectedClients: allClientIds });
        }
    };

    const handleInstallmentChange = (clientId, value) => {
        setClientsForRepayment((prevClients) =>
            prevClients.map((client) =>
                client.id === clientId ? { ...client, last_installment_no: value - 1 } : client
            )
        );
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const selectedClientsData = clientsForRepayment.map((client) => {
            let lastInstallmentNo = client.last_installment_no + 1;
            if (formData.selectedClients.includes(client.id)) {
                const updatedClient = { ...client, last_installment_no: lastInstallmentNo, is_closure: (lastInstallmentNo===26)?1:0 };
                return updatedClient;
            }
            return client;
        });

        if (selectedClientsData.filter(client => formData.selectedClients.includes(client.id)).length === 0) {
            alert("Please select at least one client for repayment.");
            return;
        }
        console.log("selectedClientsData->", selectedClientsData)
        try {
            const response = await fetch(API_ADD_LOAN_REPAYMENT_MULTIPLE, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                },
                body: JSON.stringify({
                    branch_id: formData.branch_id,
                    center_id: formData.center_id,
                    repayment_paid_by_staff: formData.repayment_paid_by_staff,
                    clients: selectedClientsData,
                    created_at: formData.created_at
                }),
            });
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            const result = await response.json();
            console.log('result ->', result)
            if (result.data && result.data.length > 0) {
                let isAllSubmitted = result.data.some(item => item.success === true);
                if (isAllSubmitted) {
                    alert("Repayment data successfully submitted!");
                    window.location.reload();
                } else {
                    alert("Repayment data submission failed!");
                }
            } else {
                alert("Failed to submit repayment data!");
            }
        } catch (error) {
            console.error("Error submitting repayment data:", error);
            alert("An error occurred. Please try again.");
        }
    };

    const getCentersByBranch = async (branchId) => {
        try {
            const response = await fetch(API_CENTERS, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                },
                body: JSON.stringify({ is_all: false, branch_id: branchId })
            });
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            const responseData = await response.json();
            setCenterList(responseData.data);
        } catch (error) {
            console.error('Error:', error);
            setCenterList([]);
        }
    };

    const getClientsForRepayment = async () => {
        if (formData.center_id) {
            try {
                const response = await fetch(API_GET_CLIENTS_FOR_REPAYMENT, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',  // Add Content-Type header
                        'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                    },
                    body: JSON.stringify({
                        branch_id: formData.branch_id,
                        center_id: formData.center_id,
                    }),
                });
                if (response.status === 401 || response.status === 403) {
                    logout(); // 👈 Token invalid or expired → logout
                    return;
                }
                const result = await response.json();
                if (result) {
                    setClientsForRepayment(result.data);
                } else {
                    setClientsForRepayment([]);
                }
            } catch (error) {
                alert("An error occurred. Please try again.");
                console.error(error);
            }
        }
    };

    useEffect(() => {
        if (formData.center_id) {
            getClientsForRepayment();
        }
    }, [formData.center_id, formData.branch_id]);

    return (
        <div className="container my-5">
            <h2 className="text-center">Loan Repayment Form</h2>
            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="branch_id" className="form-label">Branch Name</label>
                            <select
                                className="form-control"
                                name="branch_id"
                                value={formData && formData.branch_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Branch</option>
                                {branches.map((branch) => (
                                    <option key={branch.id} value={branch.id}>
                                        {branch.branch_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="center_id" className="form-label">Center Name</label>
                            <select
                                className="form-control"
                                name="center_id"
                                value={formData && formData.center_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Center</option>
                                {centerList && centerList.map((center) => (
                                    <option key={center.id} value={center.id}>
                                        {center.center_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={
                                            formData &&
                                            formData.selectedClients &&
                                            Array.isArray(clientsForRepayment) &&
                                            formData.selectedClients.length === clientsForRepayment.length
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </th>
                                <th>Client Name</th>
                                <th>Installment Amount</th>
                                <th>Installment No (1-26)</th>
                                <th>Repayment Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(clientsForRepayment) && clientsForRepayment.length > 0 && clientsForRepayment.map((client) => (
                                <tr key={client.id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={formData && formData.selectedClients && formData.selectedClients.includes(client.id)}
                                            onChange={() => handleCheckboxChange(client.id)}
                                        />
                                    </td>
                                    <td>{client.client_name}</td>
                                    <td><input type="text" value={client.installment_amt} disabled /></td>
                                    <td>
                                        <select
                                            className="form-control"
                                            value={client.last_installment_no + 1}
                                            onChange={(e) => handleInstallmentChange(client.id, e.target.value)}
                                            required
                                        >
                                            {numbers.map((number) => (
                                                <option key={number} value={number}>
                                                    {number}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="created_at"
                                            value={formData && formData.created_at}
                                            onChange={handleChange}
                                            required
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label htmlFor="repayment_paid_by_staff" className="form-label">Repayment Paid by Staff</label>
                            <select
                                className="form-control"
                                name="repayment_paid_by_staff"
                                value={formData && formData.repayment_paid_by_staff}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>Select Staff</option>
                                {employeeList.map((employee) => (
                                    <option key={employee.id} value={employee.id}>
                                        {employee.emp_generate_id}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Submit Selected Repayments</button>
                </div>
            </form>
        </div>
    );
};

export default LoanRepaymentList;
